<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-50 no-scrollbar">
    <div class="bg-white shadow-lg rounded p-6 max-w-md w-full relative mx-4">

        <!-- Header: Title + Close X -->
        <div class="flex flex-row justify-between items-center mb-4">
            <h1 class="font-bold text-xl text-gray-900">{{ title }}</h1>
            <button type="button" (click)="onCancel()" class="text-gray-400 hover:text-gray-600 focus:outline-none transition-colors">
                <i class="fas fa-xmark text-xl"></i>
            </button>
        </div>

        <!-- Icon + Message -->
        <div class="flex flex-row gap-4 items-center my-4">
            <div class="flex-shrink-0 w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
                <i class="fas text-2xl fa-triangle-exclamation text-amber-500"></i>
            </div>
            <div class="text-left overflow-hidden min-w-0">
                <p class="text-gray-600 text-sm break-words whitespace-normal leading-relaxed">{{ message }}</p>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-row gap-3 justify-end mt-6">
            <button type="button" (click)="onCancel()"
                class="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 bg-gray-100 hover:bg-gray-200 rounded-lg focus:outline-none transition-colors">
                {{ cancelText }}
            </button>
            <button type="button" (click)="onGoToBilling()"
                class="px-4 py-2 text-sm font-medium text-white bg-primary-500 hover:bg-primary-600 rounded-lg focus:outline-none shadow transition-colors flex items-center gap-2">
                <i class="fas fa-credit-card text-xs"></i>
                {{ actionText }}
            </button>
        </div>

    </div>
</div>
